module.exports = __webpack_public_path__ + "images/category_lp/car/assessment_achievements/2@2x_0dc8e7b7c4f0c1eaed1a6db2f6ebfeb5.png";